const timeseriesLoadedReducer = (state = null, action) => {
  switch(action.type) {
    case 'TIME_SERIES_LOADED':
      return action.payload;
    default:
      return state
    }
  }

  export default timeseriesLoadedReducer;